import React from "react";
import "./TrailLogsSection.scss";
import { InfoCircleIcon } from "../../../../../../assets/Icons/InfoCircleIcon";

// TrailLogsSection component displays order update trail logs at the top of the chat
export const TrailLogsSection = ({ trailLogs = [] }) => {
  if (!Array.isArray(trailLogs) || trailLogs.length === 0) {
    return null;
  }

  // Order logs so the most-recent entry appears in the second position.
  // 1) Sort by updatedDate descending (latest first).
  // 2) Swap the first two items so the latest ends up at index 1.
  const displayLogs = (() => {
    const sorted = [...trailLogs].sort((a, b) => {
      const aTime = new Date(a?.updatedDate || 0).getTime();
      const bTime = new Date(b?.updatedDate || 0).getTime();
      return bTime - aTime;
    });
    if (sorted.length >= 2) {
      [sorted[0], sorted[1]] = [sorted[1], sorted[0]];
    }
    return sorted;
  })();

  return (
    <div className="trail-logs-section-container">
      <div className="trail-logs-list">
        {displayLogs.map((log, index) => (
          <div key={index} className="trail-log-item">
            <span className="trail-log-icon">
              <InfoCircleIcon width="16" height="16" color="#737387" />
            </span>
            <span className="trail-log-message">{log.uiMessage}</span>
            <span className="trail-log-date">
              {new Date(log.updatedDate).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })}{" "}
              |{" "}
              {new Date(log.updatedDate).toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrailLogsSection;
